import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import "./index.css";

interface ErrorBoundaryState { hasError: boolean; message: string }

class AppErrorBoundary extends React.Component<React.PropsWithChildren, ErrorBoundaryState> {
  state: ErrorBoundaryState = { hasError: false, message: "" };

  static getDerivedStateFromError(error: unknown): ErrorBoundaryState {
    return { hasError: true, message: error instanceof Error ? error.message : "Unknown runtime error" };
  }

  componentDidCatch(error: unknown, info: React.ErrorInfo) {
    console.error("FTNERS Nexus workspace failed", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <main className="app-fallback" role="alert">
          <span>FTNERS NEXUS · SAFE MODE</span>
          <h1>The operations workspace could not load.</h1>
          <p>The failure was isolated so the page remains recoverable. Reload the local application to retry.</p>
          <code>{this.state.message}</code>
          <button onClick={() => window.location.reload()}>Reload workspace</button>
        </main>
      );
    }
    return this.props.children;
  }
}

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Failed to find the root element");
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <AppErrorBoundary>
      <App />
    </AppErrorBoundary>
  </React.StrictMode>,
);
